var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { ReactComponent as Pin } from '../../Map/assets/pin.svg';
const AvatarContainer = styled.div `
  cursor: pointer;
  user-select: none;
  width: calc(2 * ${props => props.theme.utils.getSize(props.size)});
  height: calc(2 * ${props => props.theme.utils.getSize(props.size)});
  display: inline-flex;
  overflow: hidden;
  position: relative;
  font-size: 1.25rem;
  align-items: center;
  flex-shrink: 0;
  line-height: 1;
  border-radius: calc(${props => props.theme.utils.getSize(props.size)} / 2.5);
  justify-content: center;
  margin: ${(props) => props.noMargin ? '0rem' : props.theme.paddingsMargins.themeMenuMargin};
  & img {
    width: calc(2 * ${props => props.theme.utils.getSize(props.size)});
    height: auto;
  }
`;
const FallbackContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: ${props => props.theme.utils.getSize(props.size)};
  font-family: ${props => props.theme.fonts.fontFamily};
  background-color: ${props => props.theme.colors.mainColor};
  font-weight: 700;
  color: white;
  padding-top: 0;
`;
const PinStyle = styled(Pin) `
  transform: rotate(90deg);
  position: absolute;
  width: 100%;
  height:100%;
  top: 0px;
  left: -25px;
  fill: ${props => props.theme.colors.secondaryColor}
`;
const Avatar = (_a) => {
    var { avatar, size = 'title', isLoading, skeleton, noMargin = false, fallback = '' } = _a, props = __rest(_a, ["avatar", "size", "isLoading", "skeleton", "noMargin", "fallback"]);
    const theme = useTheme();
    const [useFallback, setUseFallback] = useState(false);
    const createFallbackChars = (fallback) => {
        const split = fallback.toLocaleUpperCase().split(' ').splice(0, 2);
        return split.length > 1 ? split[0][0] + split[1][0] : split[0][0];
    };
    const noFallbackValue = () => {
        return theme.logo ? _jsx("img", { src: theme.logo, alt: 'my_logo', style: { width: '100%', height: 'auto', padding: theme.paddingsMargins.themeMenuPadding } }) : _jsx(PinStyle, {});
    };
    return (_jsx(AvatarContainer, Object.assign({ size: size, noMargin: noMargin }, props, { children: isLoading
            ? _jsx(Skeleton, { height: size, width: size })
            : useFallback
                ? _jsx(FallbackContainer, Object.assign({ size: size }, { children: fallback ? createFallbackChars(fallback) : noFallbackValue() }))
                : _jsx("img", { src: avatar, alt: "crono-avatar", onError: () => {
                        setUseFallback(true);
                    } }) })));
};
export default Avatar;
